import { render, staticRenderFns } from "./VoteRecord.vue?vue&type=template&id=7e8d9f86&scoped=true&"
import script from "./VoteRecord.vue?vue&type=script&lang=js&"
export * from "./VoteRecord.vue?vue&type=script&lang=js&"
import style0 from "./VoteRecord.vue?vue&type=style&index=0&id=7e8d9f86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8d9f86",
  null
  
)

export default component.exports